/**
 * A single tab page. It renders the passed template
 * via the @Input properties by using the ngTemplateOutlet
 * and ngTemplateOutletContext directives.
 */

import { Component, Input, AfterViewChecked } from '@angular/core';

@Component({
    selector: 'da-tab',
    styleUrls: ['./tab.component.scss'],
    templateUrl: './tab.component.html'
})
export class TabComponent implements AfterViewChecked {
    @Input('tabTitle') title: string;
    @Input() active = false;
    constructor() {}

    ngAfterViewChecked(): void {
        setTimeout(() => {
            // trigger scroll event to show images
            const e = document.createEvent('Event');
            e.initEvent('scroll', true, true);
            window.dispatchEvent(e);
        });
    }
}
